// alterado - revisado

import HARDCODE from '../../../business-const/HardCode/HardCode'

import {
    round
} from '../../../business-components/round/round'

import {
    pesquisaList
} from '../../../business-rules/List/ListService'

import familiaresList from '../../../business-rules/List/familiaresList'

import tipoClassificacaoImcList from '../../../business-rules/List/tipoClassificacaoImcList'

export const inicializaHistoricoSaudeRiscos = ( values ) => {

    let achouFamiliar = false

    if (!values.historicoSaudeRiscos) {
         values.historicoSaudeRiscos = []
     }

    familiaresList(values)?.forEach( (linhaFamiliaresList, index) => {
        achouFamiliar = false

        values.historicoSaudeRiscos?.forEach( (linhaHistoricoSaudeRiscos, index) => {
            if (linhaHistoricoSaudeRiscos.familiar === linhaFamiliaresList.id) {

                achouFamiliar = true
            }
        })

        if (!achouFamiliar) {

            values.historicoSaudeRiscos.push(
                {
                    familiar: linhaFamiliaresList.id,
                }
            )
        }
        
    })
}



export const processaValoresDefaultIniciaisHistoricoSaudeRiscos = ( values, item, parentescoFamiliar ) => {
    let index = ''

    if (
            parentescoFamiliar === HARDCODE.idParentescoEnteadao &&
            !item.informarHistoricoSaudeFamiliaresEnteadao
    ) {
        if (values.historicoSaudeFamiliares) {
            index = values.historicoSaudeFamiliares.length - 1

            while (index >= 0) {

                if (values.historicoSaudeFamiliares[index].familiar === item.familiar) {
                    values.historicoSaudeFamiliares.splice(index, 1)
                }

                index -= 1
            }
        }

        if (values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares) {
            index = values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares.length - 1

            while (index >= 0) {

                if (
                        values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares[index].id ===
                            item.familiar
                ) {

                    values.familiaresProcessouRegistrosDefaultIniciaisHistoricoSaudeFamiliares.splice(index, 1)
                }

                index -= 1
            }
        }



        if (values.condicaoSaude) {
            
            index = values.condicaoSaude.length - 1

            while (index >= 0) {

                if (values.condicaoSaude[index].familiar === item.familiar) {
                    values.condicaoSaude.splice(index, 1)
                }

                index -= 1
            }
        }

        if (values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude) {
            index = values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude.length - 1

            while (index >= 0) {

                if (values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude[index].id === item.familiar) {
                    values.familiaresProcessouRegistrosDefaultIniciaisCondicaoSaude.splice(index, 1)
                }

                index -= 1
            }
        }
    }
}



const calculaHistoricoSaudeRiscosImc = ( item ) => {
    if (item.peso && item.altura) {
        item.imc = Number(item.peso / (round(item.altura / 100, 2) * round(item.altura / 100, 2))).toFixed(1)

        item.tipoClassificacaoImc = ''

        tipoClassificacaoImcList?.forEach( (linhaTipoClassificacaoImc, index) => {
            if (item.imc >= linhaTipoClassificacaoImc.imcInicial &&
                item.imc <= linhaTipoClassificacaoImc.imcFinal
                ) {

                item.tipoClassificacaoImc = linhaTipoClassificacaoImc.id
            }
        })
    } else {
        item.imc = ''
        item.tipoClassificacaoImc = ''
    }
}

export const processaAlteracaoHistoricoSaudeRiscosPeso = ( item ) => {
    calculaHistoricoSaudeRiscosImc(item)
}

export const processaAlteracaoHistoricoSaudeRiscosAltura = ( item ) => {
    calculaHistoricoSaudeRiscosImc(item)
}



export const calculaCorDestaqueHistoricoSaudeRiscosTipoClassificacaoImc = ( tipoClassificacaoImc ) => {

    return pesquisaList(tipoClassificacaoImcList, tipoClassificacaoImc).corDestaque
}



const calculaHistoricoSaudeRiscosTipoFumo = ( item ) => {
    if (item.fumante === "N") {
        item.tipoFumo = ''
    }
}

const calculaHistoricoSaudeRiscosQtdeFumoSemanal = ( item ) => {
    if (item.fumante === "N") {
        item.qtdeFumoSemanal = ''
    }
}

export const processaAlteracaoHistoricoSaudeRiscosFumante = ( item ) => {
    calculaHistoricoSaudeRiscosTipoFumo(item)
    calculaHistoricoSaudeRiscosQtdeFumoSemanal(item)
}



const calculaHistoricoSaudeRiscosTipoFumoOutros = ( item ) => {
    if (item.tipoFumo !== HARDCODE.idTipoFumoOutros) {
        item.tipoFumoOutros = ''
    }
}

export const processaAlteracaoHistoricoSaudeRiscosTipoFumo = ( item ) => {
    calculaHistoricoSaudeRiscosTipoFumoOutros(item)
}



const calculaHistoricoSaudeRiscosTipoUtilizacaoMoto = ( item ) => {
    if (item.utilizaMoto === "N") {
        item.tipoUtilizacaoMoto = ''
    }
}

export const processaAlteracaoHistoricoSaudeRiscosUtilizaMoto = ( item ) => {
    calculaHistoricoSaudeRiscosTipoUtilizacaoMoto(item)
}